import React from "react"
import JotformEmbed from 'react-jotform-embed';

const Sidebar = () => {
    return (
        <>
            <h2 className="text-2xl mb-3">Quick Contact</h2>
            <JotformEmbed src="https://form.jotformeu.com/211048454575457" />
        </>
    )
}
export default Sidebar